/* eslint-disable */
<template>
  <div>
    <b-row>
      <b-col sm="8" class="row-align-left">
        <label for>
          Have you even been diagnosed with heart disease (CAD) by a health care professional
          by a health care professional?
        </label>
      </b-col>

      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.diagnosedCAD.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': cadState }"
                name="rd3"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.diagnosedCAD.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': cadState }"
                name="rd3"
                :value="false"
              > No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="8" class="row-align-left">
        <label for>
          Have you even been diagnosed with high blood pressure (hypertension)
          by a health care professional?
        </label>
      </b-col>

      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.diagnosedHighBP.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': bloodPresureState }"
                name="rd4"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.diagnosedHighBP.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': bloodPresureState }"
                name="rd4"
                :value="false"
              > No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="8" class="row-align-left">
        <label for>
          Have you ever been diagnosed with high cholesterol by a health care professional?
        </label>
      </b-col>

      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.diagnosedCholesterol.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': cholesterolState }"
                name="rd6"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.diagnosedCholesterol.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': cholesterolState }"
                name="rd6"
                :value="false"
              > No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="8" class="row-align-left">
        <label for>
          Are you physically active? Defined as 150 minutes per week of
          physical activity
        </label>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.physicallyActive.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': physicallyActiveState }"
                name="rd5"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.physicallyActive.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': physicallyActiveState }"
                name="rd5"
                :value="false"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="4" class="row-align-left">
        <label for>How tall are you?</label>
      </b-col>
      <b-col sm="2">
        <b-form-input
          type="number"
          placeholder="feet"
          :state="heightFeetState"
          min="1"
          max="9"
          v-model="$v.heightFeet.$model"
        ></b-form-input>
      </b-col>
      <b-col sm="2">
        <b-form-input
          type="number"
          placeholder="inches"
          :state="heightInchesState"
          min="0"
          max="11"
          v-model="$v.heightInches.$model"
        ></b-form-input>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="4" class="row-align-left">
        <label for>What is your weight (in pounds)?</label>
      </b-col>
      <b-col sm="2">
        <b-form-input
          type="number"
          placeholder="lbs"
          :state="weightState"
          min="0"
          max="1000"
          v-model="$v.weight.$model"
        ></b-form-input>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="4" class="row-align-left">
        <label for>BMI (Body Mass Index) number</label>
      </b-col>
      <b-col sm="2">
        <b-form-input
          type="number"
          :state="bmiState"
          min="0"
          max="1000"
          v-model="$v.bmi.$model"
        ></b-form-input>
      </b-col>
      <b-col sm="6" v-if="$v.bmi.$model == 0">
          <p>If a BMI score indicates "0", or is blank, please use BMI app located on home of iPad to calculate</p>
      </b-col>
    </b-row>
    <hr>
    <b-col md="6"><b-button size="sm" v-b-modal.my-modal>Show Body Mass Charts</b-button><b-button style="margin-left: 10px;" size="sm" v-b-modal.my-modal2>Show Points for Weight</b-button></b-col>
    <b-col md="2"></b-col>
    <b-modal id="my-modal"  size="lg" ok-only>
      <img src="@/assets/body-mass-index.png" width="725"/>
    </b-modal>
    <b-modal id="my-modal2"  size="md" ok-only>
      <weight-table></weight-table>      

    </b-modal>
    <!-- <b-row style="padding-top: 20px;">
      <b-col sm="4" class="row-align-left">
        <label for>BMI Score</label>
      </b-col>
      <b-col sm="2">
        <label>{{ surveyData.BMI}}</label>
      </b-col>
    </b-row> -->
    <survey-nav
      :step="2"
      :ShowErrorMsg="showErrorMsg"
      @move-next="moveNext"
      @move-previous="movePrevious"
    ></survey-nav>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import surveyNav from "@/components/SurveyNav";
import weightTable from "@/components/WeightTable";

export default {
  name: "survey-step2",
  props: ["surveyData", "isValid"],
  data: () => ({
    diagnosedHighBP: null,
    diagnosedCAD: null,
    diagnosedCholesterol: null,
    physicallyActive: null,
    weight: null,
    heightFeet: null,
    heightInches: null,
    bmi: null,
    showErrorMsg: false,
    BMIData: {
      "4.11": [20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,44,44,45,26,48,48,49,50],
      "5.0": [19,21,21,22,23,25,25,26,28,28,29,30,31,32,34,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49],
      "5.1": [19,20,21,22,22,24,25,25,27,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,42,43,45,45,46,47],
      "5.2": [18,19,20,21,22,23,24,25,26,27,27,28,29,30,31,32,33,34,35,35,37,37,38,40,40,41,42,43,44,45,46],
      "5.3": [18,19,20,20,21,22,23,24,25,26,27,26,29,29,30,31,32,33,34,34,36,36,37,28,39,40,41,42,43,43,44],
      "5.4": [17,18,19,20,20,22,22,23,24,25,26,27,28,28,29,30,31,32,33,33,34,35,36,37,38,39,39,41,41,42,43],
      "5.5": [17,18,18,19,20,21,22,22,24,24,25,26,27,28,28,29,30,31,32,32,33,34,35,36,37,37,38,39,40,41,42],
      "5.6": [16,17,18,19,19,20,21,22,23,24,24,25,26,27,27,28,29,30,31,31,32,33,34,35,36,36,37,38,39,40,40],
      "5.7": [16,17,17,18,19,20,20,21,22,23,24,24,25,26,27,27,28,29,30,30,31,32,33,34,35,35,36,37,38,38,39],
      "5.8": [15,16,17,17,18,19,20,20,22,22,23,24,25,25,26,27,28,28,29,30,31,31,32,33,34,34,35,36,37,37,38],
      "5.9": [15,16,16,17,18,19,19,20,21,22,22,23,24,24,25,26,27,27,28,29,30,30,31,32,33,33,34,35,36,36,37],
      "5.10": [14,15,16,17,17,18,19,19,20,21,22,22,23,24,24,25,26,27,27,28,29,30,30,31,32,32,33,34,35,35,36],
      "5.11": [14,15,15,16,17,18,18,19,20,20,21,22,23,23,24,24,25,26,27,27,28,29,29,30,31,31,32,33,34,34,35],
      "6.0": [14,14,15,16,16,17,18,18,19,20,20,21,22,23,23,24,25,25,26,26,27,28,29,29,30,31,31,32,33,33,34],
      "6.1": [13,14,15,15,16,17,17,18,19,19,20,20,21,22,22,23,24,25,25,26,27,27,28,29,29,30,30,31,32,32,33],
      "6.2": [13,14,14,15,15,16,17,17,18,19,19,20,21,21,22,22,23,24,24,25,26,26,27,28,28,29,30,30,31,32,32],
      "6.3": [12,13,14,14,15,16,16,17,18,18,19,19,20,21,21,22,23,23,24,24,25,26,26,27,28,28,29,30,30,31,31],
      "6.4": [12,13,13,14,15,15,16,16,17,18,18,19,20,20,21,21,22,23,23,24,25,25,26,26,27,28,28,29,29,30,30],
      "6.5": [12,13,13,14,14,15,16,16,17,17,18,18,19,20,20,21,22,22,23,23,24,24,25,26,26,27,27,28,29,29,30]
    },
    tableItems: [
      {height: "4' 10\"", point1: '119-142', point2: '143-190', point3: '191+'},
      {height: "4' 11\"", point1: '124-147', point2: '148-197', point3: '198+'},
      {height: "5' 0\"", point1: '128-152', point2: '153-203', point3: '204+'},
      {height: "5' 1\"", point1: '132-157', point2: '158-210', point3: '211+'},
      {height: "5' 2\"", point1: '136-163', point2: '164-217', point3: '218+'},
      {height: "5' 3\"", point1: '141-168', point2: '169-224', point3: '225+'},
      {height: "5' 4\"", point1: '145-173', point2: '174-231', point3: '232+'},
      {height: "5' 5\"", point1: '150-179', point2: '180-239', point3: '240+'},
      {height: "5' 6\"", point1: '155-185', point2: '186-246', point3: '247+'},
      {height: "5' 7\"", point1: '159-190', point2: '191-254', point3: '255+'},
      {height: "5' 8\"", point1: '164-196', point2: '197-261', point3: '262+'},
      {height: "5' 9\"", point1: '169-202', point2: '203-269', point3: '270+'},
      {height: "5' 10\"", point1: '174-208', point2: '209-277', point3: '278+'},
      {height: "5' 11\"", point1: '179-214', point2: '215-285', point3: '286+'},
      {height: "6' 0\"", point1: '184-220', point2: '221-293', point3: '294+'},
      {height: "6' 1\"", point1: '189-226', point2: '227-301', point3: '302+'},
      {height: "6' 2\"", point1: '194-232', point2: '233-310', point3: '311+'},
      {height: "6' 3\"", point1: '200-239', point2: '240-318', point3: '319+'},
      {height: "6' 4\"", point1: '205-245', point2: '246-327', point3: '328+'},
      {height: "", point1: '(1 Point)', point2: '(2 Point)', point3: '(3 Point)'}

    ]
  }),
  validations: {
    diagnosedCAD: {
      required
    },
    diagnosedHighBP: {
      required
    },
    diagnosedCholesterol: {
      required
    },
    physicallyActive: {
      required
    },
    weight: {
      required
    },
    heightFeet: {
      required
    },
    heightInches: {
      required
    },
    bmi: {
      required
    }
  },
  components: {
    surveyNav,
    weightTable
  },
  methods: {
    moveNext() {
      if (!this.$v.$invalid) this.$emit("move-next");
      else {
        this.showErrorMsg = true;
        this.$v.$touch();
      }
    },
    movePrevious() {
      this.$emit("move-previous");
    },
    onCreated() {
      this.diagnosedCAD = this.surveyData.DiagnosedCAD;
      this.diagnosedHighBP = this.surveyData.DiagnosedHighBP;
      this.diagnosedCholesterol = this.surveyData.DiagnosedCholesterol;
      this.physicallyActive = this.surveyData.PhysicallyActive;
      this.weight = this.surveyData.Weight;
      this.heightFeet = this.surveyData.HeightFeet;
      this.heightInches = this.surveyData.HeightInches;
      this.bmi = this.surveyData.BMI;
    },
    getBMI: function(){
      
    	if(this.weight == null || this.weight == 0 || this.weight == '')
        return 0;
      //debugger;
      let heightInches = '0';
      if(this.heightInches != null)
        heightInches = parseInt(this.heightInches).toString();

    	let PersonHeight = `${this.heightFeet}.${heightInches}`;
      var x = this.BMIData[PersonHeight];
      var score = x[Math.floor((this.weight  - 100) / 5)];
      this.surveyData.BMI = (score == undefined ? 0 : score);
      this.bmi = (score == undefined ? 0 : score);
      console.log('BMI Score: ' + this.surveyData.BMI);
      
    }
  },
  computed: {
    //Radio buttons must return a !result
    cadState() {
      return this.$v.diagnosedCAD.$dirty
        ? !this.$v.diagnosedCAD.required
        : null;
    },
    cholesterolState() {
      return this.$v.diagnosedCholesterol.$dirty
        ? !this.$v.diagnosedCholesterol.required
        : null;
    },
    bloodPresureState() {
      return this.$v.diagnosedHighBP.$dirty
        ? !this.$v.diagnosedHighBP.required
        : null;
    },
    physicallyActiveState() {
      return this.$v.physicallyActive.$dirty
        ? !this.$v.physicallyActive.required
        : null;
    },
    weightState() {
      return this.$v.weight.$dirty ? this.$v.weight.required : null;
    },
    heightFeetState() {
      return this.$v.heightFeet.$dirty ? this.$v.heightFeet.required : null;
    },
    heightInchesState() {
      return this.$v.heightInches.$dirty ? this.$v.heightInches.required : null;
    },
    bmiState() {
      return this.$v.bmi.$dirty ? this.$v.bmi.required : null;
    }
  },
  watch: {
    diagnosedCAD() {
      if (this.$v.diagnosedCAD.required)
        this.surveyData.DiagnosedCAD = this.diagnosedCAD;
    },
    diagnosedHighBP() {
      if (this.$v.diagnosedHighBP.required)
        this.surveyData.DiagnosedHighBP = this.diagnosedHighBP;
    },
    diagnosedCholesterol() {
      if (this.$v.diagnosedCholesterol.required)
        this.surveyData.DiagnosedCholesterol = this.diagnosedCholesterol;
    },
    physicallyActive() {
      if (this.$v.physicallyActive.required)
        this.surveyData.PhysicallyActive = this.physicallyActive;
    },
    weight() {
      if (this.$v.weight.required) {
        this.getBMI();
        this.surveyData.Weight = this.weight;
        
      }
    },
    heightFeet() {
      if (this.$v.heightFeet.required){
        this.getBMI();
        this.surveyData.HeightFeet = this.heightFeet;
      }
        
    },
    heightInches() {
      if (this.$v.heightInches.required){
        this.getBMI();
        this.surveyData.HeightInches = this.heightInches;
      }  
    },
    bmi() {
      if (this.$v.bmi.required)
        this.surveyData.BMI = this.bmi;
    },
  },
  created() {
    this.onCreated();
  }
};
</script>

<style scoped>
.invalid-radio-button {
  background-color: red;
}
</style>
<style>
 table > thead > tr:nth-child(2) {
    display:none !important; 
}
hr {
    margin-top: 5px; 
    margin-bottom: 5px;
}
</style>

